import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[fixPosition]' })
export class FixPositionDirective {
    @Input() set fixPosition(value:boolean) {
        if (value) {
            var el = <HTMLElement> this.el.nativeElement;
            setTimeout(() => {
                var rect = el.getBoundingClientRect();
                el.style.position = 'fixed';

                // 36 came from observation
                el.style.transform = 'translate(' + rect.left + 'px, ' + (rect.top - 36) + 'px)';
            })
        } else {
            var el = <HTMLElement> this.el.nativeElement;
            el.style.position = '';
            el.style.transform = '';
        }
    };
    constructor(private el: ElementRef) {}

}


// WEBPACK FOOTER //
// ./web/static/services/directives/FixPosition.ts